import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.svg';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo-container" onClick={() => scrollToSection('home')}>
            <div className="logo-wrapper">
              <img src={logo} alt="Thought Paradigm" className="logo" />
            </div>
          </div>
          
          <nav className={`navigation ${isMobileMenuOpen ? 'navigation--open' : ''}`}>
            <a href="#home" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>
              <span className="nav-link-text">Home</span>
              <span className="nav-link-indicator"></span>
            </a>
            <a href="#about" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>
              <span className="nav-link-text">About</span>
              <span className="nav-link-indicator"></span>
            </a>
            <a href="#focus" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('focus'); }}>
              <span className="nav-link-text">Focus</span>
              <span className="nav-link-indicator"></span>
            </a>
            <a href="#products" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('products'); }}>
              <span className="nav-link-text">Products</span>
              <span className="nav-link-indicator"></span>
            </a>
            <a href="#contact" className="nav-link nav-link--cta" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>
              <span className="nav-link-text">Contact Us</span>
            </a>
          </nav>

          <button 
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'mobile-menu-toggle--open' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            <span className="mobile-menu-line"></span>
            <span className="mobile-menu-line"></span>
            <span className="mobile-menu-line"></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
